import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPermission } from '../../api/login/loginApi';

const initialPermissionSlice: IPermission[] = []

const permissionSlice = createSlice({
  name: 'permissionSlice',
  initialState: initialPermissionSlice,
  reducers: {
    setPermission: (state, action: PayloadAction<IPermission[]>) => action.payload,
    clearPermission: (state) => initialPermissionSlice
  }
})

export const selectorPermission = (state: { permissionSlice: IPermission[] }) => state.permissionSlice;
export const { setPermission, clearPermission } = permissionSlice.actions;
export default permissionSlice.reducer;
